<div
  class="banner-background row px-5 py-2 mx-0"
  [style.background]="'url(' + backgroundImageUrl + ')'"
  [style.background-repeat]="'no-repeat'"
  [style.background-size]="'cover'"
  [style.background-position]="'top'"
>
  <div class="header-icons-list text-white">
    <div class="pt-1 d-flex justify-content-md-start justify-content-center">
      <span class="text-size-32 mt-1 d-flex text-md-left text-center main-title">
        {{ title }}
      </span>
    </div>
    <div class="pt-2">
      <span class="text-size-18 font-weight-light w-100 text-md-left text-center">
        {{ subTitle }}
      </span>
    </div>
    <div class="d-md-block d-none text-white w-100">
      <div
        class="d-md-flex d-none justify-content-between text-white header-icons-wrapper"
      >
        <hr class="col-12 my-2 d-md-block d-none color-white mt-1 pt-1 header-divider" />
        <div class="d-flex justify-content-between w-100">
          <app-banner-icon
            *ngFor="let icon of icons"
            [backgroundImageUrl]="icon.iconPath"
            [title]="icon.title"
            [description]="icon.description"
            [color]="'white'"
          />
        </div>
      </div>
    </div>
    <div class="pt-3 d-flex justify-content-center actions">
      <app-floating-button
        link="https://pilotworkshop.com/products/vfr-mastery/?disc=36"
        label="FREE VFR MASTERY TRIAL"
      />
      <app-floating-button
        link="https://pilotworkshop.com/products/ifr-mastery/?disc=36"
        label="FREE IFR MASTERY TRIAL"
      />
    </div>
  </div>
  <div class="top-right-logo"></div>
</div>
